// src/helpers/apis/validateOrderLines.ts
import { apiPost } from "./apis/apiHelper";
import { ProductValidationResponse } from "./apis/productHelper";

export const validateOrderLines = async (
    itemNumbers: string[]
): Promise<ProductValidationResponse[]> => {
    const response = await apiPost<ProductValidationResponse[], string[]>(
        "/api/product/VerifyProducts",
        itemNumbers
    );
    return response ?? [];
};
